module.exports = {
  localhttp: "https://embassyportal.schoolsmart.org.uk",
  // localhttp: "http://schoolsmart.org.uk",

  localhttpNG: "http://8822fd95.ngrok.io",
};
